import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmSpecificForm from '../../../components/forms/FirearmSpecificForm';
import { useCreateFirearmSpecific } from '../../../hooks/useFirearmSpecificApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmSpecificDTO } from '../../../services/apiClient';

const FirearmSpecificCreate: React.FC = () => {
  const createFirearmSpecific = useCreateFirearmSpecific();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Specifics', href: '/admin/firearmspecifics' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmSpecificDTO) => {
    try {
      await createFirearmSpecific.mutateAsync(data);
      navigate('/admin/firearmspecifics');
    } catch (error) {
      console.error('Error creating FirearmSpecific:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmspecifics"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmSpecific.Edit'
    >
        <FirearmSpecificForm
          initialValues={{} as FirearmSpecificDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmspecifics')}
        />
    </AdminLayout>
  );
};

export default FirearmSpecificCreate;